import * as React from "react";
import { Download } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
const policyData = [{
  id: "cancellation",
  title: "Cancellation Policy",
  heading1: "1. Standard Cancellation",
  text1: "Full refund for cancellations made within 48 hours of booking, if the check-in date is at least 14 days away. 50% refund for cancellations made at least 7 days before check-in. No refunds for cancellations made within 7 days of check-in.",
  heading2: "2. Refund Process",
  text2: "All refunds are processed back to the original PayPal account used for the deposit. Processing may take 5-10 business days depending on your bank's policies. Please contact us directly for any billing inquiries.",
  heading3: "3. No-Show Policy",
  text3: "Guests who do not arrive on their scheduled check-in date without prior notice will be charged the full amount of the reservation and the booking will be released. We recommend notifying our 24-hour front desk of any travel delays."
}, {
  id: "payment",
  title: "Payment & Rates",
  heading1: "1. Rates & Occupancy",
  text1: "Our base rate is $120 USD per night for up to 2 guests. For additional guests (up to 9 total), a fee of $35 USD per person per night applies. Weekend rates (Fri-Sun) are $125 USD per night.",
  heading2: "2. Deposit Payments",
  text2: "A deposit is required via our secured PayPal link at the time of booking. This deposit secures your dates at Paradise Palms and is deducted from your total balance. Guest information is saved for easy rebooking.",
  heading3: "3. Final Balance",
  text3: "The remaining balance of your reservation is due upon arrival at 6 Wendy Close. We accept USD cash or major credit cards at our 24-hour front desk service to ensure a smooth check-in experience."
}, {
  id: "house-rules",
  title: "Stay Guidelines",
  heading1: "1. Check-In & Front Desk",
  text1: "Check-in begins at 3:00 PM. Our 24-hour front desk service is available to assist you with arrivals at any time, provided your flight details have been shared for airport pick-up coordination.",
  heading2: "2. Transportation Services",
  text2: "We offer airport pick-up and drop-off for your convenience. Local beach rides are available for a flat rate of $20 USD per trip to ensure you enjoy Montego Bay's beautiful shores with ease.",
  heading3: "3. Property Care",
  text3: "Paradise Palms is a 4-bed, 3-bath home designed for comfort. We ask guests to respect the property and our neighbors. Any damages incurred during the stay will be the responsibility of the registered guest."
}];
export default function BookingTerms() {
  return <section data-section-id="85508" id="cancellation-terms" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4 font-sans tracking-tighter">
            Cancellation & Booking Policy
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-sans leading-relaxed">
            Everything you need to know about your stay at 6 Wendy Close, Montego Bay, to ensure a seamless Jamaican getaway.
          </p>
        </div>

        <Tabs defaultValue={policyData[0].id} className="w-full">
          <TabsList className="grid w-full grid-cols-1 md:grid-cols-3 h-auto mb-8 bg-muted/30 backdrop-blur-sm p-1.5 rounded-2xl">
            {policyData.map((tab, i) => <TabsTrigger key={tab.id} value={tab.id} data-index={i} className="py-3.5 text-base font-medium rounded-xl data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:shadow-lg transition-all duration-300">
                {tab.title}
              </TabsTrigger>)}
          </TabsList>

          {policyData.map((tab, i) => <TabsContent key={tab.id} value={tab.id} data-index={i} className="mt-0 outline-none">
              <ScrollArea className="h-[450px] w-full rounded-3xl border border-border/50 bg-card/80 backdrop-blur-md p-6 md:p-10 shadow-xl">
                <div className="space-y-10 text-card-foreground pr-4">
                  <section>
                    <h3 className="text-xl font-bold mb-4 text-primary font-sans tracking-tight">
                      {tab.heading1}
                    </h3>
                    <p className="leading-relaxed text-muted-foreground text-base font-sans">
                      {tab.text1}
                    </p>
                  </section>
                  
                  <section>
                    <h3 className="text-xl font-bold mb-4 text-primary font-sans tracking-tight">
                      {tab.heading2}
                    </h3>
                    <p className="leading-relaxed text-muted-foreground text-base font-sans whitespace-pre-line">
                      {tab.text2}
                    </p>
                  </section>
                  
                  <section>
                    <h3 className="text-xl font-bold mb-4 text-primary font-sans tracking-tight">
                      {tab.heading3}
                    </h3>
                    <p className="leading-relaxed text-muted-foreground text-base font-sans">
                      {tab.text3}
                    </p>
                  </section>
                </div>
              </ScrollArea>
            </TabsContent>)}
        </Tabs>

        <div className="mt-12 flex justify-center">
          <Button variant="default" size="lg" className="gap-2 rounded-full px-10 py-6 bg-primary text-primary-foreground hover:shadow-primary/20 shadow-lg transition-all font-sans font-semibold">
            <Download className="w-5 h-5" />
            Download Full Rental Agreement
          </Button>
        </div>
      </div>
    </section>;
}